export const CHANGE_LOGIN_STATE = 'CHANGE_LOGIN_STATE'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const USER = 'USER'
export const MENU_THEME = 'MENU_THEME'
